import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  radioButton: {
    fontSize: 14
  }
})

export default useStyles
